import { useEffect, useState } from "react"
import { ConnectUser } from "../api/ConnectApi"
import { useTranslation } from "react-i18next"

interface UserRowProps {
  connectProjectId: string
  userId: string
  user?: ConnectUser
  taskChanges?: { __typename: string; taskId: string; changeType: string }[]
  taskId?: number
}

export const UserRow = (props: UserRowProps) => {
  const { taskId, taskChanges } = props
  const [desired_taskChange, setDesired_taskChange] = useState<string | undefined>("")
  const { t } = useTranslation("tasks")
  useEffect(() => {
    const d_taskChange = taskChanges?.find(
      (item: { __typename: string; taskId: string; changeType: string }) => item.taskId === taskId?.toString()
    )
    if (d_taskChange?.changeType === "New") {
      setDesired_taskChange(t("tasksChanges.new").toUpperCase())
    } else if (d_taskChange?.changeType === "Updated") {
      setDesired_taskChange(t("tasksChanges.updated").toUpperCase())
    } else if (d_taskChange?.changeType === "Deleted") {
      setDesired_taskChange(t("tasksChanges.deleted").toUpperCase())
    }
  }, [taskChanges, taskId, t])

  return (
    <div className="row-center justify-content-between">
      <div className="d-flex">
        <div className="mr-2 avatar small borderless">
          <Thumbnail {...props} />
        </div>
        <div className="text-ellipsis">
          <UserLink {...props} />
          <EmployerField {...props} />
        </div>
      </div>
      <div style={{ fontWeight: "500" }}>{desired_taskChange}</div>
    </div>
  )
}

const Thumbnail = (props: UserRowProps) => {
  const { user } = props
  if (user) {
    const { thumbnail } = user
    const thumbnailUrl = thumbnail.includes("?")
      ? `${thumbnail}&accessToken=${localStorage.getItem("tc-access-token")}`
      : thumbnail
    return <img src={thumbnailUrl} alt={`thumbnail ${userFullName(user)}`} />
  } else {
    return <></>
  }
}

const UserLink = (props: UserRowProps) => {
  const { connectProjectId, userId, user } = props
  if (user) {
    const link = `https://web.connect.trimble.com/projects/${connectProjectId}/team/${user.id}`
    return (
      <h5 className="text-ellipsis">
        <a href={link} target="_blank" rel="noreferrer" className="link-secondary">
          {/* <a href={link} target="_parent" className="link-secondary"> /* Navigating parent window does not work */}
          {userFullName(user)}
        </a>
      </h5>
    )
  } else {
    return <>(User ID: {userId})</>
  }
}

const EmployerField = (props: UserRowProps) => {
  if (props.user) {
    const companyName = props.user.company?.name
    return <>{companyName && <small className="text-meta text-ellipsis">{companyName}</small>}</>
  } else {
    return <></>
  }
}

export const userFullName = (user?: ConnectUser) => (user ? `${user.firstName} ${user.lastName}` : "")
